/**
 * Angebot (Pricing/Packages) content page generator
 */
import { esc } from '@/utils/escape';
import { generateSubpageShell } from './subpage-shell';

export function generateAngebotHTML(settings: any, components: any): string {
  const page = settings.pageAngebot || {};
  const sec = page.sections || {};
  const packages = page.packages || [];

  const packagesHTML = packages.map(function(pkg: any) {
    const features = (pkg.features || '').split(',').map(function(f: string) {
      return f.trim();
    }).filter(Boolean);
    const featuresHTML = features.map(function(f: string) {
      return '            <li>' + esc(f) + '</li>';
    }).join('\n');

    return '        <div class="pricing-card' + (pkg.highlighted ? ' pricing-card--highlighted' : '') + '">\n' +
      '          <div class="pricing-card__name">' + esc(pkg.name) + '</div>\n' +
      '          <div class="pricing-card__price">' + esc(pkg.price) + '</div>\n' +
      '          <p class="pricing-card__description">' + esc(pkg.description) + '</p>\n' +
      '          <ul class="pricing-card__features">\n' +
      featuresHTML + '\n' +
      '          </ul>\n' +
      '          <a href="index.html#kontakt" class="btn btn--primary">' + esc(pkg.ctaText || 'Anfragen') + '</a>\n' +
      '        </div>';
  }).join('\n');

  const bodyContent =
    '      <section class="content-page__hero">\n' +
    '        <h1>' + esc(page.heroTitle || 'Unsere Angebote') + '</h1>\n' +
    '        <p>' + esc(page.heroSubtitle || '') + '</p>\n' +
    '      </section>\n\n' +
    (sec.packages !== false ? '      <section class="pricing-grid">\n' +
    packagesHTML + '\n' +
    '      </section>\n\n' : '') +
    (sec.cta !== false && page.ctaTitle ? '      <section class="page-cta">\n' +
    '        <h2>' + esc(page.ctaTitle) + '</h2>\n' +
    '        <p>' + esc(page.ctaText || '') + '</p>\n' +
    '        <a href="index.html#kontakt" class="btn btn--primary">' + esc(page.ctaButtonText || 'Anfragen') + '</a>\n' +
    '      </section>\n' : '');

  return generateSubpageShell(settings, components, {
    title: page.heroTitle || 'Angebot',
    metaDesc: page.heroSubtitle || '',
    bodyContent: bodyContent,
  });
}
